
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useMatomo } from '@jonkoops/matomo-tracker-react'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip'

import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'
import {
  Link,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  appRouter,
  C,
  logg, loggt,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  ActionsVerticalMenu,
} from '$src/components'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  PeriodsCtx,
} from '$src/components/periods'
import {
  ReportsCtx,
} from '$src/components/reports'
import {
  SchedulesCtx,
} from '$src/components/schedules'


// Modal.setAppElement('#root');

/**
 * ReportsModal
**/
const ReportsModal = (props) => {
  // logg(props, 'ReportsModal')

  const apiRouter = useApiRouter()
  const { trackPageView, trackEvent } = useMatomo()

  /* ctx */

  const {
    cuEmail,
    jwtToken,
    loading, setLoading,
    scope, setScope,
    selectedResource, setSelectedResource, defaultSelectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in ReportsModal')

  const {
    selectedBanks, setSelectedBanks,
    sortedResults,
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in ReportsModal')

  const {
    selectedPeriods, setSelectedPeriods,
    selectedPeriodsReverse,
  } = useContext(PeriodsCtx)
  // logg(useContext(PeriodsCtx), 'PeriodsCtx in ReportsModal')

  const {
    includeContacts,  setIncludeContacts,
    reportsList,      refreshReportsList,
    reportModalOpen,  setReportModalOpen,
    reportsModalOpen, setReportsModalOpen,
  } = useContext(ReportsCtx)
  // loggt(useContext(ReportsCtx), 'ReportsCtx in ReportsModal')

  const {
    schedulesModalOpen, setSchedulesModalOpen,
    schedulesResults,   setSchedulesResults,
  } = useContext(SchedulesCtx)

  /* state */

  const [ filteredReportsList, setFilteredReportsList ] = useState(reportsList)
  const [ selectedFormat, setSelectedFormat ] = useState('csv')

  const _selectedRssds = Object.keys(selectedBanks)
  const selectedRssds  = sortedResults.filter((a, idx) => _selectedRssds.indexOf(`${a.rssd}`) >= 0).map((a, idx) => a.rssd).join(',')
  const formRef = useRef(null)

  /* effects */

  useEffect(() => {
    const local_scope = {...scope}
    // if (local_scope[C.scope.company]) { local_scope[C.scope.mine] = true }

    const tmp = reportsList.filter((r, idx) => {
      return local_scope[r.scope]
    })
    setFilteredReportsList(tmp)
  }, [ reportsList, scope ])

  useEffect(() => {
    // trackPageView()
    trackEvent({ category: 'ReportsModal', action: 'show' })
  }, [ reportsModalOpen ])

  /* methods */

  const handleClear = () => {
    setSelectedResource(defaultSelectedResource)
    setIncludeContacts(false)
  }

  const handleModify = () => {
    setReportModalOpen(true)
  }

  const handleRun = () => {
    if (Object.keys(selectedBanks).length === 0) {
      toast('Please select bank(s) to run a report')
      return
    }
    if (!selectedResource.id) {
      toast('Please select which report to run')
      return
    }
    switch (selectedFormat) {
      case C.formats.web:
        setLoading(true)
        fetch(apiRouter.reportRunPath({ id: selectedResource.id, format: 'json' }), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              rssds: selectedRssds,
            }),
          }).then(r => r.json()).then(rows => {
            logg(rows, 'rows')
            setSchedulesResults(rows.banks)
            setLoading(false)
            setSchedulesModalOpen(true)
          })
        break
      // case C.formats.pdf:
      //   window.open(apiRouter.reportRunPath({ id: selectedResource.id, format: selectedFormat,
      //     fontSize, itemsPerRow, portraitNotLandscape, }), "_blank")
      //   break
      default:
        // window.location = apiRouter.reportRunPath({ id: selectedResource.id, format: selectedFormat, includeContacts,  })
        toast('Generating your report - please do not close the page')
        formRef.current.submit()
    }
  }

  return <F>
    <form target="_blank" ref={formRef} method="post"
        action={apiRouter.reportRunPath({ format: selectedFormat, id: selectedResource.id, includeContacts })} >
      <input type="hidden" name="rssds" value={selectedRssds} />
      <input type="hidden" name="jwt_token" value={jwtToken} />
      <input type="hidden" name="periods" value={Object.keys(selectedPeriods).join(',')} />
      <input type="hidden" name="periods_reverse" value={selectedPeriodsReverse} />
    </form>

    <Modal
      ariaHideApp={false}
      className="Boxed2Modal BaseModal DoL"
      isOpen={reportsModalOpen}
      onRequestClose={() => {
        handleClear()
        setReportsModalOpen(false)
      } }
      overlayClassName="ReportsModalOverlay"
    >
      <div className='header'>
        <h5 >Single Fi  Reports</h5>
        <div className='close' onClick={() => {
          handleClear()
          setReportsModalOpen(false)
        } }>&times;</div>
      </div>



      <div className='C1'>
        <div className='boxedList'>
          <div className='boxedListC'
            onClick={(event) => {
              if (event.target === event.currentTarget) {
                setSelectedResource(defaultSelectedResource)
              }
            } }
          >
            { /* Reports list */ }
            { filteredReportsList.map((opt, idx) => <div key={idx}
                data-report-id={opt.value}
                className={`item-1 ${opt.value === selectedResource.id ? 'active' : ''}`}
                onClick={() => {
                  setSelectedResource({ ...opt, kind: C.kinds.Report })
                } }
              >
              <div className='left'>
                <input checked={opt.value === selectedResource.id} type='radio' name='selected-report'
                  readOnly={true}
                  />&nbsp;{ opt.label }
              </div>
              <div className='right'>
                { opt.email === cuEmail && 'mine' }
                { opt.email === 'reports@fedfis.com' && 'standard' }
                { [cuEmail, 'reports@fedfis.com'].indexOf(opt.email) === -1 && <F>by { opt.email }</F> }
              </div>
            </div> )}
          </div>
        </div>
        <ActionsVerticalMenu clear={handleClear}
          handleModify={handleModify}
          kind={C.kinds.Report} />
      </div>

      <div className='FiltersBox'>
        <label className='label-main' >Filters</label>
        <div className='FiltersBoxC'>
          <Checkbox
            checked={!!scope[C.scope.mine]}
            onChange={(ev) => {
              if (scope[C.scope.mine]) {
                delete scope[C.scope.mine]
              } else {
                scope[C.scope.mine] = true
              }
              setScope({...scope})
            }}
          /><label>Mine</label>
          <Checkbox
            checked={!!scope[C.scope.standard]}
            onChange={(ev) => {
              if (scope[C.scope.standard]) {
                delete scope[C.scope.standard]
              } else {
                scope[C.scope.standard] = true
              }
              setScope({...scope})
            }}
          /><label>Standard</label>
          <Checkbox
            checked={!!scope[C.scope.company]}
            onChange={(ev) => {
              if (scope[C.scope.company]) {
                delete scope[C.scope.company]
              } else {
                scope[C.scope.company] = true
              }
              setScope({...scope})
            }}
          /><label>Company</label>
          <Checkbox
            checked={!!scope[C.scope.shared]}
            onChange={(ev) => {
              if (scope[C.scope.shared]) {
                delete scope[C.scope.shared]
              } else {
                scope[C.scope.shared] = true
              }
              setScope({...scope})
            }}
          /><label>Shared with me</label>
        </div>
      </div>

      <div className='actions'>
        <div className='left'>
          <Checkbox checked={includeContacts} onChange={(ev) => {
            setIncludeContacts(ev.target.checked)
            setSelectedFormat('csv')
          } }/>
          <label>Include Contact Information</label>
        </div>
        <div className='right'>

          { includeContacts && <div className='gray'>Only csv export is available<br />with contacts</div> || <div className='formatW'>
              <label>Format&nbsp;&nbsp;</label>
              <Select className='select2'
                isSearchable={false}
                menuPlacement={'top'}
                onChange={(ev) => setSelectedFormat(ev.value)}
                options={[
                  { label: 'csv', value: 'csv' },
                  { label: 'web', value: 'web' },
                ]}
                style={C.select2Styles}
                value={C.formatOpts.filter(e => e.value === selectedFormat)}
              />
            </div> }

          { Object.keys(selectedBanks).length ?
            <button disabled={!selectedResource.id} className='Btn btn-primary'
              onClick={handleRun}>Run</button> :
            <OverlayTrigger placement="top"
              overlay={<Tooltip>Please select bank(s) to run any report.</Tooltip>}
            ><button disabled={true} className='Btn btn-primary'>Run</button>
            </OverlayTrigger> }

        </div>
      </div>

    </Modal>
  </F>
}
export default ReportsModal



